import React from 'react';
import CharacterInfo from './CharacterInfo';
import CharacterImage from './CharacterImage';

export default (props) => (
    <React.Fragment>
        <CharacterInfo />
        <CharacterImage />
    </React.Fragment>
)